module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-cottonbro-agile1-dbdaa898fc4ec1f4256720dd2e07a471.jpg";